import { jsx as _jsx } from "react/jsx-runtime";
import { defineMessages, useIntl } from 'react-intl';
import YearSelect from '../YearSelect';
var messages = defineMessages({
    ReferenceYear: {
        id: 'ReferenceYear',
        defaultMessage: 'ReferenceYear',
    },
    WithoutReferenceYear: {
        id: 'WithoutReferenceYear',
        defaultMessage: 'Without reference year',
    },
});
export var FilterReferenceYear = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    var formatMessage = useIntl().formatMessage;
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(YearSelect, { id: "yearFilter", value: activeFilters[item], onChange: function (value) {
                var _a;
                setFilter((_a = {}, _a[item] = value, _a));
            }, placeholder: formatMessage(messages.ReferenceYear), withoutOption: formatMessage(messages.WithoutReferenceYear) })),
    };
};
